import { CodeStep } from './CodeStep'
import { NameStep } from './NameStep'
import { PhoneStep } from './PhoneStep'
import type { AuthScreenProps } from './types'

/**
 * §7.9's whole client flow: Phone → OTP → name capture (D42) → Home. Purely a step switch —
 * every field and every transition is owned by whatever supplies `AuthScreenProps` (see
 * `types.ts`); this component makes no request and stores nothing.
 */
export function AuthScreen({ step, phoneStep, codeStep, nameStep }: AuthScreenProps): JSX.Element {
  switch (step) {
    case 'phone':
      return <PhoneStep {...phoneStep} />
    case 'code':
      return <CodeStep {...codeStep} />
    case 'name':
      return <NameStep {...nameStep} />
  }
}
